// externals
import { createSelector } from 'reselect';

// libraries
import { scopedStateSelectors } from '@makemydeal/shared-scoped-store';

const getGlobalState = (state: any) => state.__global;

const getPrimaryScopeOwnState = (state: any) => {
    const primaryScopeId = scopedStateSelectors.getPrimaryScopeId(state);
    return primaryScopeId ? scopedStateSelectors.getScopeStateById(state, primaryScopeId, false) : undefined;
};

const getMergedPrimaryScopeState = createSelector([getGlobalState, getPrimaryScopeOwnState], (globalState, scopeState) =>
    scopeState ? { ...globalState, ...scopeState } : undefined
);

export const getPrimaryScopeState = (state: any) => getMergedPrimaryScopeState(state) || state;
